var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          ref: "stationDailyPlatformDiscountData",
          attrs: {
            id: "stationDailyPlatformDiscountData",
            data: _vm.stationDailyPlatformDiscountData,
            "highlight-current-row": "",
            height: "600",
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            "cell-style": _vm.cellStyle,
            "header-cell-style": { "text-align": "center" },
            border: ""
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              label: "平台",
              prop: "platName"
            }
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                align: "center",
                label:
                  "日期：" +
                  _vm.timestamp2datestring(_vm.end / 1000, "YY年MM月DD日")
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayCountStations",
                  label: "油站数"
                }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "dayNums", label: "总升数" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "dayDiscount", label: "总优惠" }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffPrice",
                  label: "总均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffPrice92",
                  label: "92#均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffPrice95",
                  label: "95#均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffPrice0",
                  label: "0#均价"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                align: "center",
                label:
                  "月份：" +
                  _vm.timestamp2datestring(_vm.end / 1000, "YY年MM月")
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthCountStations",
                  label: "油站数"
                }
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "monthNums", label: "总升数" }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiscount",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffPrice",
                  label: "总均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffPrice92",
                  label: "92#均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffPrice95",
                  label: "95#均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffPrice0",
                  label: "0#均价"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }